import { slug } from '@/helpers/urlTs';
import { DEFAULT_MY_LOCATION_KEYWORD, DEFAULT_SEARCH_LOCATION } from '@/hooks/search/useSearch.constants';
import { _s } from '@/locale';
import { MegaMenuSubCategory } from './Category.types';

const baseTranslationKey = 'features.mega-menu.modules.Category.constants';

function translate(key: string) {
  return _s(`${baseTranslationKey}.${key}`);
}

function createLink(keyword = DEFAULT_SEARCH_LOCATION, location = DEFAULT_SEARCH_LOCATION, query?: string) {
  return `/${slug(keyword)}/${slug(location)}${query ? query : ''}`;
}

export const HAIRDRESSER_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-services'),
    icon: 'tags',
    links: [
      {
        label: translate('Klippning'),
        to: createLink('Klippning'),
      },
      {
        label: translate('Herrklippning'),
        to: createLink('Herrklippning'),
      },
      {
        label: translate('Slingor'),
        to: createLink('Slingor'),
      },
      {
        label: translate('Hårförlängning'),
        to: createLink('Hårförlängning'),
      },
      {
        label: translate('Barberare'),
        to: createLink('Barberare'),
      },
      {
        label: translate('Barnklippning'),
        to: createLink('Barnklippning'),
      },
      {
        label: translate('Balayage'),
        to: createLink('Balayage'),
      },
      {
        label: translate('Keratin'),
        to: createLink('Keratin'),
      },
      {
        label: translate('Olaplex'),
        to: createLink('Olaplex'),
      },
    ],
  },
  {
    title: translate('popular-searches'),
    icon: 'search-check',
    links: [
      {
        label: translate('Frisör nära mig'),
        to: createLink('frisör', DEFAULT_MY_LOCATION_KEYWORD),
      },
      {
        label: translate('Frisör Stockholm'),
        to: createLink('frisör', 'Stockholm'),
      },
      {
        label: translate('Frisör Göteborg'),
        to: createLink('Frisör', 'Göteborg'),
      },
      {
        label: translate('Frisör Malmö'),
        to: createLink('Frisör', 'Malmö'),
      },
      {
        label: translate('Frisör Uppsala'),
        to: createLink('Frisör', 'Uppsala'),
      },
      {
        label: translate('Frisör Västerås'),
        to: createLink('Frisör', 'Västerås'),
      },
      {
        label: translate('Frisör Örebro'),
        to: createLink('Frisör', 'Örebro'),
      },
      {
        label: translate('Frisör Linköping'),
        to: createLink('Frisör', 'Linköping'),
      },
      {
        label: translate('Frisör Jönköping'),
        to: createLink('Frisör', 'Jönköping'),
      },
    ],
  },
];

export const MASSAGE_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-services'),
    icon: 'tags',
    links: [
      {
        label: translate('Thaimassage'),
        to: createLink('Thaimassage'),
      },
      {
        label: translate('Svensk massage'),
        to: createLink('Svensk massage'),
      },
      {
        label: translate('Klassisk massage'),
        to: createLink('Klassisk massage'),
      },
      {
        label: translate('Lymfmassage'),
        to: createLink('Lymfmassage'),
      },
      {
        label: translate('Gravidmassage'),
        to: createLink('Gravidmassage'),
      },
      {
        label: translate('Fotmassage'),
        to: createLink('Fotmassage'),
      },
      {
        label: translate('Ansiktsmassage'),
        to: createLink('Ansiktsmassage'),
      },
      {
        label: translate('Taktil massage'),
        to: createLink('Taktil massage'),
      },
      {
        label: translate('Koppningsmassage'),
        to: createLink('Koppningsmassage'),
      },
    ],
  },

  {
    title: translate('popular-searches'),
    icon: 'search-check',
    links: [
      { label: translate('Massage nära mig'), to: createLink('Massage', DEFAULT_MY_LOCATION_KEYWORD) },
      { label: translate('Massage Stockholm'), to: createLink('Massage', 'Stockholm') },
      { label: translate('Massage Göteborg'), to: createLink('Massage', 'Göteborg') },
      { label: translate('Massage Malmö'), to: createLink('Massage', 'Malmö') },
      { label: translate('Massage Uppsala'), to: createLink('Massage', 'Uppsala') },
      { label: translate('Massage Västerås'), to: createLink('Massage', 'Västerås') },
      { label: translate('Massage Örebro'), to: createLink('Massage', 'Örebro') },
      { label: translate('Massage Linköping'), to: createLink('Massage', 'Linköping') },
      { label: translate('Massage Helsingborg'), to: createLink('Massage', 'Helsingborg') },
    ],
  },
];

export const NAILS_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-services'),
    icon: 'tags',
    links: [
      {
        label: translate('Pedikyr'),
        to: createLink('Pedikyr'),
      },
      {
        label: translate('Nagelförlängning'),
        to: createLink('Nagelförlängning'),
      },
      {
        label: translate('Manikyr'),
        to: createLink('Manikyr'),
      },
      {
        label: translate('Nagelvård'),
        to: createLink('Nagelvård'),
      },
      {
        label: translate('Gellack'),
        to: createLink('Gellack'),
      },
      {
        label: translate('Gele naglar'),
        to: createLink('Gele naglar'),
      },
      {
        label: translate('Akrylnaglar'),
        to: createLink('Akrylnaglar'),
      },
      {
        label: translate('Fransk manikyr'),
        to: createLink('Fransk manikyr'),
      },
      {
        label: translate('Borttagning'),
        to: createLink('Borttagning'),
      },
      {
        label: translate('Reparation'),
        to: createLink('Reparation'),
      },
    ],
  },
  {
    title: translate('popular-searches'),
    icon: 'search-check',
    links: [
      {
        label: translate('Naglar nära mig'),
        to: createLink('Naglar', DEFAULT_MY_LOCATION_KEYWORD),
      },
      {
        label: translate('Naglar Stockholm'),
        to: createLink('Naglar', 'Stockholm'),
      },
      {
        label: translate('Naglar Göteborg'),
        to: createLink('Naglar', 'Göteborg'),
      },
      {
        label: translate('Naglar Malmö'),
        to: createLink('Naglar', 'Malmö'),
      },
      {
        label: translate('Naglar Uppsala'),
        to: createLink('Naglar', 'Uppsala'),
      },
      {
        label: translate('Naglar Västerås'),
        to: createLink('Naglar', 'Västerås'),
      },
      {
        label: translate('Naglar Örebro'),
        to: createLink('Naglar', 'Örebro'),
      },
      {
        label: translate('Naglar Helsingborg'),
        to: createLink('Naglar', 'Helsingborg'),
      },
    ],
  },
];

export const LASHES_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-services'),
    icon: 'tags',
    links: [
      {
        label: translate('Fransar'),
        to: createLink('Fransar'),
      },
      {
        label: translate('Fransförlängning'),
        to: createLink('Fransförlängning'),
      },
      {
        label: translate('Lashlift'),
        to: createLink('Lashlift'),
      },
      {
        label: translate('Ögonbryn'),
        to: createLink('Ögonbryn'),
      },
      {
        label: translate('Browlift'),
        to: createLink('Browlift'),
      },
      {
        label: translate('Microblading'),
        to: createLink('Microblading'),
      },
      {
        label: translate('Trådning'),
        to: createLink('Trådning'),
      },
      {
        label: translate('Singel fransar'),
        to: createLink('Singel fransar'),
      },
      {
        label: translate('Fransfärgning'),
        to: createLink('Fransfärgning'),
      },
      {
        label: translate('Volymfransar'),
        to: createLink('Volymfransar'),
      },
    ],
  },
  {
    title: translate('popular-searches'),
    icon: 'search-check',
    links: [
      {
        label: translate('Lashlift nära mig'),
        to: createLink('Lashlift', DEFAULT_MY_LOCATION_KEYWORD),
      },
      {
        label: translate('Lashlift Stockholm'),
        to: createLink('Lashlift', 'Stockholm'),
      },
      {
        label: translate('Lashlift Göteborg'),
        to: createLink('Lashlift', 'Göteborg'),
      },
      {
        label: translate('Lashlift Malmö'),
        to: createLink('Lashlift', 'Malmö'),
      },
      {
        label: translate('Browlift nära mig'),
        to: createLink('Browlift', DEFAULT_MY_LOCATION_KEYWORD),
      },
      {
        label: translate('Browlift Stockholm'),
        to: createLink('Browlift', 'Stockholm'),
      },
      {
        label: translate('Browlift Göteborg'),
        to: createLink('Browlift', 'Göteborg'),
      },
      {
        label: translate('Browlift Malmö'),
        to: createLink('Browlift', 'Malmö'),
      },
      {
        label: translate('Microblading Stockholm'),
        to: createLink('Microblading', 'Stockholm'),
      },
      {
        label: translate('Microblading Göteborg'),
        to: createLink('Microblading', 'Göteborg'),
      },
    ],
  },
];

export const SKINCARE_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-services'),
    icon: 'tags',
    links: [
      {
        label: translate('Ansiktsbehandling'),
        to: createLink('Ansiktsbehandling'),
      },
      {
        label: translate('Microneedling'),
        to: createLink('Microneedling'),
      },
      {
        label: translate('Headspa'),
        to: createLink('Headspa'),
      },
      {
        label: translate('LPG'),
        to: createLink('LPG'),
      },
      {
        label: translate('HIFU'),
        to: createLink('HIFU'),
      },
      {
        label: translate('Dermapen'),
        to: createLink('Dermapen'),
      },
      {
        label: translate('Pigmentfläckar'),
        to: createLink('Pigmentfläckar'),
      },
      {
        label: translate('Rosaceabehandling'),
        to: createLink('Rosaceabehandling'),
      },
      {
        label: translate('Kärlbehandling'),
        to: createLink('Kärlbehandling'),
      },
      {
        label: translate('Aknebehandling'),
        to: createLink('Aknebehandling'),
      },
    ],
  },
  {
    title: translate('popular-searches'),
    icon: 'search-check',
    links: [
      {
        label: translate('Ansiktsbehandling nära mig'),
        to: createLink('Ansiktsbehandling', DEFAULT_MY_LOCATION_KEYWORD),
      },
      {
        label: translate('Ansiktsbehandling Stockholm'),
        to: createLink('Ansiktsbehandling', 'Stockholm'),
      },
      {
        label: translate('Ansiktsbehandling Göteborg'),
        to: createLink('Ansiktsbehandling', 'Göteborg'),
      },
      {
        label: translate('Ansiktsbehandling Malmö'),
        to: createLink('Ansiktsbehandling', 'Malmö'),
      },
      {
        label: translate('Microneedling Stockholm'),
        to: createLink('Microneedling', 'Stockholm'),
      },
      {
        label: translate('Microneedling Göteborg'),
        to: createLink('Microneedling', 'Göteborg'),
      },
      {
        label: translate('Microneedling Malmö'),
        to: createLink('Microneedling', 'Malmö'),
      },
      {
        label: translate('LPG Stockholm'),
        to: createLink('LPG', 'Stockholm'),
      },
      {
        label: translate('LPG Göteborg'),
        to: createLink('LPG', 'Göteborg'),
      },
      {
        label: translate('LPG Malmö'),
        to: createLink('LPG', 'Malmö'),
      },
    ],
  },
];

export const BEAUTY_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-services'),
    icon: 'tags',
    links: [
      {
        label: translate('Fillers'),
        to: createLink('Fillers'),
      },
      {
        label: translate('Piercing'),
        to: createLink('Piercing'),
      },
      {
        label: translate('Spraytan'),
        to: createLink('Spraytan'),
      },
      {
        label: translate('Tandblekning'),
        to: createLink('Tandblekning'),
      },
      {
        label: translate('Tatuering'),
        to: createLink('Tatuering'),
      },
      {
        label: translate('Kosmetisk tatuering'),
        to: createLink('Kosmetisk tatuering'),
      },
      {
        label: translate('Makeup'),
        to: createLink('Makeup'),
      },
      {
        label: translate('Skinbooster'),
        to: createLink('Skinbooster'),
      },
      {
        label: translate('PRP'),
        to: createLink('PRP'),
      },
      {
        label: translate('Hyperhidros'),
        to: createLink('Hyperhidros'),
      },
    ],
  },
  {
    title: translate('popular-searches'),
    icon: 'search-check',
    links: [
      {
        label: translate('Piercing nära mig'),
        to: createLink('Piercing', DEFAULT_MY_LOCATION_KEYWORD),
      },
      {
        label: translate('Piercing Stockholm'),
        to: createLink('Piercing', 'Stockholm'),
      },
      {
        label: translate('Piercing Göteborg'),
        to: createLink('Piercing', 'Göteborg'),
      },
      {
        label: translate('Piercing Malmö'),
        to: createLink('Piercing', 'Malmö'),
      },
      {
        label: translate('Tatuering Stockholm'),
        to: createLink('Tatuering', 'Stockholm'),
      },
      {
        label: translate('Tatuering Göteborg'),
        to: createLink('Tatuering', 'Göteborg'),
      },
      {
        label: translate('Tatuering Malmö'),
        to: createLink('Tatuering', 'Malmö'),
      },
      {
        label: translate('Tandblekning Stockholm'),
        to: createLink('Tandblekning', 'Stockholm'),
      },
      {
        label: translate('Spraytan Stockholm'),
        to: createLink('Spraytan', 'Stockholm'),
      },
      {
        label: translate('Spraytan Örebro'),
        to: createLink('Spraytan', 'Örebro'),
      },
    ],
  },
];
export const HEALTH_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-services'),
    icon: 'tags',
    links: [
      {
        label: translate('Kiropraktik'),
        to: createLink('Kiropraktik'),
      },
      {
        label: translate('Naprapati'),
        to: createLink('Naprapati'),
      },
      {
        label: translate('Medicinsk fotvård'),
        to: createLink('Medicinsk fotvård'),
      },
      {
        label: translate('Estetisk fotvård'),
        to: createLink('Estetisk fotvård'),
      },
      {
        label: translate('Akupunktur'),
        to: createLink('Akupunktur'),
      },
      {
        label: translate('Yoga'),
        to: createLink('Yoga'),
      },
      {
        label: translate('Träning'),
        to: createLink('Träning'),
      },
      {
        label: translate('Sjukgymnastik'),
        to: createLink('Sjukgymnastik'),
      },
      {
        label: translate('Samtalsterapi'),
        to: createLink('Samtalsterapi'),
      },
      {
        label: translate('Healing'),
        to: createLink('Healing'),
      },
    ],
  },
  {
    title: translate('popular-searches'),
    icon: 'search-check',
    links: [
      {
        label: translate('Fotvård nära mig'),
        to: createLink('Fotvård', DEFAULT_MY_LOCATION_KEYWORD),
      },
      {
        label: translate('Fotvård Stockholm'),
        to: createLink('Fotvård', 'Stockholm'),
      },
      {
        label: translate('Fotvård Göteborg'),
        to: createLink('Fotvård', 'Göteborg'),
      },
      {
        label: translate('Fotvård Malmö'),
        to: createLink('Fotvård', 'Malmö'),
      },
      {
        label: translate('Yoga Stockholm'),
        to: createLink('Yoga', 'Stockholm'),
      },
      {
        label: translate('Yoga Göteborg'),
        to: createLink('Yoga', 'Göteborg'),
      },
      {
        label: translate('Hot yoga Stockholm'),
        to: createLink('Hot yoga', 'Stockholm'),
      },
      {
        label: translate('Hot yoga Malmö'),
        to: createLink('Hot yoga', 'Malmö'),
      },
      {
        label: translate('Spa Stockholm'),
        to: createLink('Spa', 'Stockholm'),
      },
      {
        label: translate('Spa Göteborg'),
        to: createLink('Spa', 'Göteborg'),
      },
    ],
  },
];

export const SISTAMINUTEN_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-sistaminuten'),
    icon: 'tags',
    links: [
      {
        label: translate('Frisör'),
        to: `/sistaminuten${createLink('Frisör')}`,
      },
      {
        label: translate('Barberare'),
        to: `/sistaminuten${createLink('Barberare')}`,
      },
      {
        label: translate('Massage'),
        to: `/sistaminuten${createLink('Massage')}`,
      },
      {
        label: translate('Hudvård'),
        to: `/sistaminuten${createLink('Hudvård')}`,
      },
      {
        label: translate('Ansiktsbehandling'),
        to: `/sistaminuten${createLink('Ansiktsbehandling')}`,
      },
      {
        label: translate('Lashlift'),
        to: `/sistaminuten${createLink('Lashlift')}`,
      },
      {
        label: translate('Browlift'),
        to: `/sistaminuten${createLink('Browlift')}`,
      },
      {
        label: translate('Naglar'),
        to: `/sistaminuten${createLink('Naglar')}`,
      },
      {
        label: translate('Manikyr'),
        to: `/sistaminuten${createLink('Manikyr')}`,
      },
      {
        label: translate('Pedikyr'),
        to: `/sistaminuten${createLink('Pedikyr')}`,
      },
    ],
  },
];

export const DEALS_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-deals'),
    icon: 'campaign',
    links: [
      {
        label: translate('Frisör'),
        to: `/deals${createLink('Frisör')}`,
      },
      {
        label: translate('Barberare'),
        to: `/deals${createLink('Barberare')}`,
      },
      {
        label: translate('Massage'),
        to: `/deals${createLink('Massage')}`,
      },
      {
        label: translate('Hudvård'),
        to: `/deals${createLink('Hudvård')}`,
      },
      {
        label: translate('Ansiktsbehandling'),
        to: `/deals${createLink('Ansiktsbehandling')}`,
      },
      {
        label: translate('Lashlift'),
        to: `/deals${createLink('Lashlift')}`,
      },
      {
        label: translate('Browlift'),
        to: `/deals${createLink('Browlift')}`,
      },
      {
        label: translate('Naglar'),
        to: `/deals${createLink('Naglar')}`,
      },
      {
        label: translate('Manikyr'),
        to: `/deals${createLink('Manikyr')}`,
      },
      {
        label: translate('Pedikyr'),
        to: `/deals${createLink('Pedikyr')}`,
      },
    ],
  },
];

export const WELLNESSCARD_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-wellness'),
    icon: 'wellness',
    links: [
      {
        label: translate('Massage'),
        to: createLink('Massage', undefined, '?wellness=1'),
      },
      {
        label: translate('Thaimassage'),
        to: createLink('Thaimassage', undefined, '?wellness=1'),
      },
      {
        label: translate('Ansiktsmassage'),
        to: createLink('Ansiktsmassage', undefined, '?wellness=1'),
      },
      {
        label: translate('Fotmassage'),
        to: createLink('Fotmassage', undefined, '?wellness=1'),
      },
      {
        label: translate('Lymfmassage'),
        to: createLink('Lymfmassage', undefined, '?wellness=1'),
      },
      {
        label: translate('Gravidmassage'),
        to: createLink('Gravidmassage', undefined, '?wellness=1'),
      },
      {
        label: translate('Koppningsmassage'),
        to: createLink('Koppningsmassage', undefined, '?wellness=1'),
      },
      {
        label: translate('Taktil massage'),
        to: createLink('Taktil massage', undefined, '?wellness=1'),
      },
      {
        label: translate('Naprapati'),
        to: createLink('Naprapati', undefined, '?wellness=1'),
      },
      {
        label: translate('Kiropraktik'),
        to: createLink('Kiropraktik', undefined, '?wellness=1'),
      },
      {
        label: translate('Träning'),
        to: createLink('Träning', undefined, '?wellness=1'),
      },
      {
        label: translate('Personlig träning (PT)'),
        to: createLink('Personlig träning', undefined, '?wellness=1'),
      },
      {
        label: translate('Yoga'),
        to: createLink('Yoga', undefined, '?wellness=1'),
      },
      {
        label: translate('Hot yoga'),
        to: createLink('Hot yoga', undefined, '?wellness=1'),
      },
      {
        label: translate('Akupunktur'),
        to: createLink('Akupunktur', undefined, '?wellness=1'),
      },
      {
        label: translate('Samtalsterapi'),
        to: createLink('Samtalsterapi', undefined, '?wellness=1'),
      },
    ],
  },
];

export const GIFTCARD_SUB_CATEGORIES: MegaMenuSubCategory[] = [
  {
    title: translate('popular-giftcard'),
    icon: 'gift',
    links: [
      { label: translate('Frisör'), to: createLink('Frisör', undefined, '?gc=1') },
      { label: translate('Massage'), to: createLink('Massage', undefined, '?gc=1') },
      { label: translate('Thaimassage'), to: createLink('Thaimassage', undefined, '?gc=1') },
      { label: translate('Ansiktsmassage'), to: createLink('Ansiktsmassage', undefined, '?gc=1') },
      { label: translate('Naglar'), to: createLink('Naglar', undefined, '?gc=1') },
      { label: translate('Pedikyr'), to: createLink('Pedikyr', undefined, '?gc=1') },
      { label: translate('Manikyr'), to: createLink('Manikyr', undefined, '?gc=1') },
      { label: translate('Hudvård'), to: createLink('Hudvård', undefined, '?gc=1') },
      { label: translate('Ansiktsbehandling'), to: createLink('Ansiktsbehandling', undefined, '?gc=1') },
      { label: translate('Microneedling'), to: createLink('Microneedling', undefined, '?gc=1') },
      { label: translate('Lashlift'), to: createLink('Lashlift', undefined, '?gc=1') },
      { label: translate('Browlift'), to: createLink('Browlift', undefined, '?gc=1') },
      { label: translate('Microblading'), to: createLink('Microblading', undefined, '?gc=1') },
      { label: translate('Spa'), to: createLink('Spa', undefined, '?gc=1') },
      { label: translate('Piercing'), to: createLink('Piercing', undefined, '?gc=1') },
      { label: translate('Spraytan'), to: createLink('Spraytan', undefined, '?gc=1') },
    ],
  },
];

export const MORE_CATEGORY_KEYS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'Å',
  'Ä',
  'Ö',
] as const;

export type MoreCategoryKey = (typeof MORE_CATEGORY_KEYS)[number];

type MoreCategory = { label: string; to: string };

const MORE_CATEGORIES: MoreCategory[] = [
  { label: translate('Akne'), to: createLink('Akne', undefined, undefined) },
  { label: translate('Aknebehandling'), to: createLink('Aknebehandling', undefined, undefined) },
  { label: translate('Akrylnaglar'), to: createLink('Akrylnaglar', undefined, undefined) },
  { label: translate('Akupressur'), to: createLink('Akupressur', undefined, undefined) },
  { label: translate('Akupunktur'), to: createLink('Akupunktur', undefined, undefined) },
  {
    label: translate('Alternativmedicin'),
    to: createLink('Alternativmedicin', undefined, undefined),
  },
  {
    label: translate('Andningsmassage'),
    to: createLink('Andningsmassage', undefined, undefined),
  },
  {
    label: translate('Ansiktslyft utan kirurgi'),
    to: createLink('Ansiktslyft utan kirurgi', undefined, undefined),
  },
  {
    label: translate('Aromamassage'),
    to: createLink('Aromamassage', undefined, undefined),
  },
  { label: translate('Ashtanga Yoga'), to: createLink('Ashtanga Yoga', undefined, undefined) },
  { label: translate('Ayurveda'), to: createLink('Ayurveda', undefined, undefined) },
  {
    label: translate('Ayurvedisk Massage'),
    to: createLink('Ayurvedisk Massage', undefined, undefined),
  },
  {
    label: translate('Ansiktsbehandling djuprengörande'),
    to: createLink('Ansiktsbehandling djuprengörande', undefined, undefined),
  },
  { label: translate('Babylights'), to: createLink('Babylights', undefined, undefined) },
  { label: translate('Balayage'), to: createLink('Balayage', undefined, undefined) },
  { label: translate('Bambumassage'), to: createLink('Bambumassage', undefined, undefined) },
  { label: translate('Barber'), to: createLink('Barber', undefined, undefined) },
  { label: translate('Barnklippning'), to: createLink('Barnklippning', undefined, undefined) },
  { label: translate('BIAB'), to: createLink('BIAB', undefined, undefined) },
  { label: translate('Blowout'), to: createLink('Blowout', undefined, undefined) },
  { label: translate('Bottenfärg'), to: createLink('Bottenfärg', undefined, undefined) },
  { label: translate('Brynformning'), to: createLink('Brynformning', undefined, undefined) },
  { label: translate('Brynfärgning'), to: createLink('Brynfärgning', undefined, undefined) },
  { label: translate('Brynplockning'), to: createLink('Brynplockning', undefined, undefined) },
  {
    label: translate('Bröllopsuppsättning'),
    to: createLink('Bröllopsuppsättning', undefined, undefined),
  },
  { label: translate('Celluliter'), to: createLink('Celluliter', undefined, undefined) },
  { label: translate('Coachning'), to: createLink('Coachning', undefined, undefined) },
  {
    label: translate('Color correction'),
    to: createLink('Color correction', undefined, undefined),
  },
  { label: translate('Cryoterapi'), to: createLink('Cryoterapi', undefined, undefined) },

  { label: translate('Damklippning'), to: createLink('Damklippning', undefined, undefined) },
  { label: translate('Dermapen'), to: createLink('Dermapen', undefined, undefined) },
  { label: translate('Diamantslipning'), to: createLink('Diamantslipning', undefined, undefined) },

  { label: translate('Enzympeeling'), to: createLink('Enzympeeling', undefined, undefined) },
  { label: translate('Extensions'), to: createLink('Extensions', undefined, undefined) },
  {
    label: translate('Extensions borttagning'),
    to: createLink('Extensions borttagning', undefined, undefined),
  },
  {
    label: translate('Eyeliner-tatuering'),
    to: createLink('Eyeliner-tatuering', undefined, undefined),
  },
  { label: translate('Face framing'), to: createLink('Face framing', undefined, undefined) },
  {
    label: translate('Faceliftmassage'),
    to: createLink('Faceliftmassage', undefined, undefined),
  },
  {
    label: translate('Fet hårbotten'),
    to: createLink('Fet hårbotten', undefined, undefined),
  },
  { label: translate('Fettreducering'), to: createLink('Fettreducering', undefined, undefined) },
  { label: translate('Fibromassage'), to: createLink('Fibromassage', undefined, undefined) },
  { label: translate('Fillers'), to: createLink('Fillers', undefined, undefined) },
  { label: translate('Fotmassage'), to: createLink('Fotmassage', undefined, undefined) },
  { label: translate('Fotsvamp'), to: createLink('Fotsvamp', undefined, undefined) },
  { label: translate('Fotvård'), to: createLink('Fotvård', undefined, undefined) },
  { label: translate('Fransar'), to: createLink('Fransar', undefined, undefined) },
  {
    label: translate('Fransborttagning'),
    to: createLink('Fransborttagning', undefined, undefined),
  },
  { label: translate('Fransfärgning'), to: createLink('Fransfärgning', undefined, undefined) },
  {
    label: translate('Fransförlängning'),
    to: createLink('Fransförlängning', undefined, undefined),
  },
  {
    label: translate('Fransförlängning Megavolym'),
    to: createLink('Fransförlängning Megavolym', undefined, undefined),
  },
  {
    label: translate('Fransförlängning Volym'),
    to: createLink('Fransförlängning Volym', undefined, undefined),
  },
  {
    label: translate('Fransk manikyr'),
    to: createLink('Fransk manikyr', undefined, undefined),
  },
  {
    label: translate('Fransrengöring'),
    to: createLink('Fransrengöring', undefined, undefined),
  },
  {
    label: translate('Frekvensterapi'),
    to: createLink('Frekvensterapi', undefined, undefined),
  },
  { label: translate('Friskvård'), to: createLink('Friskvård', undefined, undefined) },
  {
    label: translate('Friskvårdsmassage'),
    to: createLink('Friskvårdsmassage', undefined, undefined),
  },
  { label: translate('Frisör'), to: createLink('Frisör', undefined, undefined) },
  {
    label: translate('Funktionsanalys'),
    to: createLink('Funktionsanalys', undefined, undefined),
  },
  { label: translate('Färgning'), to: createLink('Färgning', undefined, undefined) },
  { label: translate('Föning'), to: createLink('Föning', undefined, undefined) },
  { label: translate('Gel naglar'), to: createLink('Gel naglar', undefined, undefined) },
  { label: translate('Gelenaglar'), to: createLink('Gelenaglar', undefined, undefined) },
  { label: translate('Gellack'), to: createLink('Gellack', undefined, undefined) },
  {
    label: translate('Gellack med förstärkning'),
    to: createLink('Gellack med förstärkning', undefined, undefined),
  },
  { label: translate('Gravidmassage'), to: createLink('Gravidmassage', undefined, undefined) },
  { label: translate('Gravidyoga'), to: createLink('Gravidyoga', undefined, undefined) },
  { label: translate('Gruppträning'), to: createLink('Gruppträning', undefined, undefined) },
  {
    label: translate('Gua Sha-massage'),
    to: createLink('Gua Sha-massage', undefined, undefined),
  },

  { label: translate('Hatha Yoga'), to: createLink('Hatha Yoga', undefined, undefined) },
  { label: translate('Headspa'), to: createLink('Headspa', undefined, undefined) },
  { label: translate('Healing'), to: createLink('Healing', undefined, undefined) },
  { label: translate('Herrklippning'), to: createLink('Herrklippning', undefined, undefined) },
  { label: translate('HIFU'), to: createLink('HIFU', undefined, undefined) },
  {
    label: translate('Hollywood Peel'),
    to: createLink('Hollywood Peel', undefined, undefined),
  },
  {
    label: translate('Hot Stone Massage'),
    to: createLink('Hot Stone Massage', undefined, undefined),
  },
  { label: translate('Hot yoga'), to: createLink('Hot yoga', undefined, undefined) },
  { label: translate('Hudföryngring'), to: createLink('Hudföryngring', undefined, undefined) },
  {
    label: translate('Huduppstramning'),
    to: createLink('Huduppstramning', undefined, undefined),
  },
  { label: translate('Hudvård'), to: createLink('Hudvård', undefined, undefined) },
  {
    label: translate('Hyaluronsyra'),
    to: createLink('Hyaluronsyra', undefined, undefined),
  },
  { label: translate('Hyperhidros'), to: createLink('Hyperhidros', undefined, undefined) },
  { label: translate('Hypnos'), to: createLink('Hypnos', undefined, undefined) },
  {
    label: translate('Hårborttagning'),
    to: createLink('Hårborttagning', undefined, undefined),
  },
  {
    label: translate('Hårbottenbehandling'),
    to: createLink('Hårbottenbehandling', undefined, undefined),
  },
  {
    label: translate('Hårförlängning'),
    to: createLink('Hårförlängning', undefined, undefined),
  },
  { label: translate('Hårvård'), to: createLink('Hårvård', undefined, undefined) },
  { label: translate('Hälsa'), to: createLink('Hälsa', undefined, undefined) },
  { label: translate('Hälsprickor'), to: createLink('Hälsprickor', undefined, undefined) },

  {
    label: translate('Idrottsmassage'),
    to: createLink('Idrottsmassage', undefined, undefined),
  },
  { label: translate('IPL'), to: createLink('IPL', undefined, undefined) },
  {
    label: translate('IPL hårborttagning'),
    to: createLink('IPL hårborttagning', undefined, undefined),
  },
  { label: translate('IR-massage'), to: createLink('IR-massage', undefined, undefined) },

  {
    label: translate('Japansk massage'),
    to: createLink('Japansk massage', undefined, undefined),
  },

  { label: translate('K18'), to: createLink('K18', undefined, undefined) },
  { label: translate('Katun fransar'), to: createLink('Katun fransar', undefined, undefined) },
  {
    label: translate('Kemisk peeling'),
    to: createLink('Kemisk peeling', undefined, undefined),
  },
  {
    label: translate('Keratinbehandling'),
    to: createLink('Keratinbehandling', undefined, undefined),
  },
  { label: translate('Kinesiologi'), to: createLink('Kinesiologi', undefined, undefined) },
  {
    label: translate('Kinesisk medicin'),
    to: createLink('Kinesisk medicin', undefined, undefined),
  },
  {
    label: translate('Tuina-massage'),
    to: createLink('Tuina-massage', undefined, undefined),
  },
  { label: translate('Kiropraktik'), to: createLink('Kiropraktik', undefined, undefined) },
  { label: translate('Klangmassage'), to: createLink('Klangmassage', undefined, undefined) },
  { label: translate('Klippning'), to: createLink('Klippning', undefined, undefined) },
  {
    label: translate('Klippning & Slingor'),
    to: createLink('Klippning & Slingor', undefined, undefined),
  },
  {
    label: translate('Klippning ungdom'),
    to: createLink('Klippning ungdom', undefined, undefined),
  },
  {
    label: translate('Koppningsmassage'),
    to: createLink('Koppningsmassage', undefined, undefined),
  },
  {
    label: translate('Kosmetisk tatuering'),
    to: createLink('Kosmetisk tatuering', undefined, undefined),
  },
  {
    label: translate('Kostrådgivning'),
    to: createLink('Kostrådgivning', undefined, undefined),
  },
  {
    label: translate('Kroppsinpackning'),
    to: createLink('Kroppsinpackning', undefined, undefined),
  },
  {
    label: translate('Kroppspeeling'),
    to: createLink('Kroppspeeling', undefined, undefined),
  },
  {
    label: translate('Käkledsbehandling'),
    to: createLink('Käkledsbehandling', undefined, undefined),
  },
  { label: translate('Kärlbehandling'), to: createLink('Kärlbehandling', undefined, undefined) },

  { label: translate('Laserbehandling'), to: createLink('Laserbehandling', undefined, undefined) },
  {
    label: translate('Lashlift Keratin'),
    to: createLink('Lashlift Keratin', undefined, undefined),
  },
  {
    label: translate('LED-ljusterapi'),
    to: createLink('LED-ljusterapi', undefined, undefined),
  },
  { label: translate('Liktornar'), to: createLink('Liktornar', undefined, undefined) },
  { label: translate('LPG'), to: createLink('LPG', undefined, undefined) },
  {
    label: translate('LPG-behandling'),
    to: createLink('LPG-behandling', undefined, undefined),
  },
  { label: translate('LPG-massage'), to: createLink('LPG-massage', undefined, undefined) },
  { label: translate('Luggklippning'), to: createLink('Luggklippning', undefined, undefined) },
  { label: translate('Lymfmassage'), to: createLink('Lymfmassage', undefined, undefined) },
  {
    label: translate('Läpptatuering'),
    to: createLink('Läpptatuering', undefined, undefined),
  },

  { label: translate('Makeup'), to: createLink('Makeup', undefined, undefined) },
  { label: translate('Manikyr & Pedikyr'), to: createLink('Manikyr & Pedikyr', undefined, undefined) },
  { label: translate('Massage'), to: createLink('Massage', undefined, undefined) },
  {
    label: translate('Medial vägledning'),
    to: createLink('Medial vägledning', undefined, undefined),
  },
  {
    label: translate('Medicinsk massage'),
    to: createLink('Medicinsk massage', undefined, undefined),
  },
  { label: translate('Meditation'), to: createLink('Meditation', undefined, undefined) },
  { label: translate('Medium'), to: createLink('Medium', undefined, undefined) },
  {
    label: translate('Megavolymfransar'),
    to: createLink('Megavolymfransar', undefined, undefined),
  },
  { label: translate('Melasma'), to: createLink('Melasma', undefined, undefined) },
  { label: translate('Mesoterapi'), to: createLink('Mesoterapi', undefined, undefined) },
  { label: translate('MicroPen'), to: createLink('MicroPen', undefined, undefined) },
  { label: translate('Microshading'), to: createLink('Microshading', undefined, undefined) },
  { label: translate('Mixfransar'), to: createLink('Mixfransar', undefined, undefined) },

  {
    label: translate('Nagelförlängning'),
    to: createLink('Nagelförlängning', undefined, undefined),
  },
  {
    label: translate('Nagelförlängning akryl'),
    to: createLink('Nagelförlängning akryl', undefined, undefined),
  },
  {
    label: translate('Nagelförlängning gelé'),
    to: createLink('Nagelförlängning gelé', undefined, undefined),
  },
  {
    label: translate('Nagelförlängning glasfiber'),
    to: createLink('Nagelförlängning glasfiber', undefined, undefined),
  },
  {
    label: translate('Nagelförlängning silke'),
    to: createLink('Nagelförlängning silke', undefined, undefined),
  },
  {
    label: translate('Nagelförstärkning'),
    to: createLink('Nagelförstärkning', undefined, undefined),
  },
  { label: translate('Nagelklippning'), to: createLink('Nagelklippning', undefined, undefined) },
  { label: translate('Nagelsvamp'), to: createLink('Nagelsvamp', undefined, undefined) },
  { label: translate('Nageltrång'), to: createLink('Nageltrång', undefined, undefined) },
  { label: translate('Nagelvård'), to: createLink('Nagelvård', undefined, undefined) },
  { label: translate('Naglar borttagning'), to: createLink('Naglar borttagning', undefined, undefined) },
  { label: translate('Naglar reparation'), to: createLink('Naglar reparation', undefined, undefined) },
  { label: translate('Naprapati'), to: createLink('Naprapati', undefined, undefined) },
  { label: translate('Navelpiercing'), to: createLink('Navelpiercing', undefined, undefined) },
  { label: translate('NBE-massage'), to: createLink('NBE-massage', undefined, undefined) },
  { label: translate('Ny frisyr'), to: createLink('Ny frisyr', undefined, undefined) },

  { label: translate('Olaplex'), to: createLink('Olaplex', undefined, undefined) },
  {
    label: translate('Olaplexbehandling'),
    to: createLink('Olaplexbehandling', undefined, undefined),
  },
  { label: translate('Ombre'), to: createLink('Ombre', undefined, undefined) },
  { label: translate('Ombre brows'), to: createLink('Ombre brows', undefined, undefined) },
  { label: translate('Ombre naglar'), to: createLink('Ombre naglar', undefined, undefined) },
  { label: translate('Optiker'), to: createLink('Optiker', undefined, undefined) },
  { label: translate('Ortobionomi'), to: createLink('Ortobionomi', undefined, undefined) },
  { label: translate('Ortopedi'), to: createLink('Ortopedi', undefined, undefined) },
  { label: translate('Osteopati'), to: createLink('Osteopati', undefined, undefined) },

  {
    label: translate('Paraffinbehandling'),
    to: createLink('Paraffinbehandling', undefined, undefined),
  },
  { label: translate('Pedikyr'), to: createLink('Pedikyr', undefined, undefined) },
  {
    label: translate('Pensionärklippning'),
    to: createLink('Pensionärklippning', undefined, undefined),
  },
  { label: translate('Permanent'), to: createLink('Permanent', undefined, undefined) },
  {
    label: translate('Permanent hårborttagning'),
    to: createLink('Permanent hårborttagning', undefined, undefined),
  },
  {
    label: translate('Permanent ögonbrynsmakeup'),
    to: createLink('Permanent ögonbrynsmakeup', undefined, undefined),
  },
  {
    label: translate('Personal shopper'),
    to: createLink('Personal shopper', undefined, undefined),
  },
  {
    label: translate('Personlig tränare'),
    to: createLink('Personlig tränare', undefined, undefined),
  },
  { label: translate('Picolaser'), to: createLink('Picolaser', undefined, undefined) },
  { label: translate('Piercing'), to: createLink('Piercing', undefined, undefined) },
  {
    label: translate('Pigmentbehandling'),
    to: createLink('Pigmentbehandling', undefined, undefined),
  },
  { label: translate('Pigmentfläckar'), to: createLink('Pigmentfläckar', undefined, undefined) },
  { label: translate('Plastikkirurgi'), to: createLink('Plastikkirurgi', undefined, undefined) },
  { label: translate('Powder brows'), to: createLink('Powder brows', undefined, undefined) },
  { label: translate('Power Yoga'), to: createLink('Power Yoga', undefined, undefined) },
  {
    label: translate('PRP (Platelet Rich Plasma)'),
    to: createLink('PRP (Platelet Rich Plasma)', undefined, undefined),
  },
  { label: translate('PRX-T33'), to: createLink('PRX-T33', undefined, undefined) },
  { label: translate('Psoriasis'), to: createLink('Psoriasis', undefined, undefined) },
  { label: translate('PT'), to: createLink('PT', undefined, undefined) },

  {
    label: translate('Radiofrekvens'),
    to: createLink('Radiofrekvens', undefined, undefined),
  },
  { label: translate('Rakning'), to: createLink('Rakning', undefined, undefined) },
  { label: translate('Reflexologi'), to: createLink('Reflexologi', undefined, undefined) },
  {
    label: translate('Regndroppsmassage'),
    to: createLink('Regndroppsmassage', undefined, undefined),
  },
  { label: translate('Reiki'), to: createLink('Reiki', undefined, undefined) },
  { label: translate('Reikihealing'), to: createLink('Reikihealing', undefined, undefined) },
  {
    label: translate('Reiki massage'),
    to: createLink('Reiki massage', undefined, undefined),
  },
  {
    label: translate('Restorative Yoga'),
    to: createLink('Restorative Yoga', undefined, undefined),
  },
  { label: translate('Rosacea'), to: createLink('Rosacea', undefined, undefined) },
  { label: translate('Rosenmetoden'), to: createLink('Rosenmetoden', undefined, undefined) },
  { label: translate('Ryggmassage'), to: createLink('Ryggmassage', undefined, undefined) },

  {
    label: translate('Samtalsterapi'),
    to: createLink('Samtalsterapi', undefined, undefined),
  },
  { label: translate('Senioryoga'), to: createLink('Senioryoga', undefined, undefined) },
  { label: translate('Shiatsu'), to: createLink('Shiatsu', undefined, undefined) },
  { label: translate('Singelfransar'), to: createLink('Singelfransar', undefined, undefined) },
  { label: translate('Sjukgymnastik'), to: createLink('Sjukgymnastik', undefined, undefined) },
  { label: translate('Skalpmassage'), to: createLink('Skalpmassage', undefined, undefined) },
  { label: translate('Skinbooster'), to: createLink('Skinbooster', undefined, undefined) },
  { label: translate('Sklerosering'), to: createLink('Sklerosering', undefined, undefined) },
  { label: translate('Skoinlägg'), to: createLink('Skoinlägg', undefined, undefined) },
  { label: translate('Skägg'), to: createLink('Skägg', undefined, undefined) },
  { label: translate('Skäggfärgning'), to: createLink('Skäggfärgning', undefined, undefined) },
  { label: translate('Skäggklippning'), to: createLink('Skäggklippning', undefined, undefined) },
  { label: translate('Skäggtrimmning'), to: createLink('Skäggtrimmning', undefined, undefined) },
  { label: translate('Skönhet'), to: createLink('Skönhet', undefined, undefined) },
  { label: translate('Slingor'), to: createLink('Slingor', undefined, undefined) },
  { label: translate('Sockring'), to: createLink('Sockring', undefined, undefined) },
  { label: translate('Spa'), to: createLink('Spa', undefined, undefined) },
  {
    label: translate('Spa manikyr & pedikyr'),
    to: createLink('Spa manikyr & pedikyr', undefined, undefined),
  },
  { label: translate('Spa-manikyr'), to: createLink('Spa-manikyr', undefined, undefined) },
  { label: translate('Spa-pedikyr'), to: createLink('Spa-pedikyr', undefined, undefined) },
  { label: translate('Spraytan'), to: createLink('Spraytan', undefined, undefined) },
  { label: translate('Stylist'), to: createLink('Stylist', undefined, undefined) },
  { label: translate('Sugaring'), to: createLink('Sugaring', undefined, undefined) },
  {
    label: translate('Svensk massage'),
    to: createLink('Svensk massage', undefined, undefined),
  },
  { label: translate('Svettbehandling'), to: createLink('Svettbehandling', undefined, undefined) },

  {
    label: translate('Taktil massage'),
    to: createLink('Taktil massage', undefined, undefined),
  },
  { label: translate('Tandblekning'), to: createLink('Tandblekning', undefined, undefined) },
  { label: translate('Tandläkare'), to: createLink('Tandläkare', undefined, undefined) },
  { label: translate('Tatuering'), to: createLink('Tatuering', undefined, undefined) },
  {
    label: translate('Tatueringsborttagning'),
    to: createLink('Tatueringsborttagning', undefined, undefined),
  },
  { label: translate('Terapi'), to: createLink('Terapi', undefined, undefined) },
  { label: translate('Thaimassage'), to: createLink('Thaimassage', undefined, undefined) },
  { label: translate('Toning'), to: createLink('Toning', undefined, undefined) },
  {
    label: translate('Torr hårbotten'),
    to: createLink('Torr hårbotten', undefined, undefined),
  },
  { label: translate('Torrborstning'), to: createLink('Torrborstning', undefined, undefined) },
  {
    label: translate('Triggerpunktsmassage'),
    to: createLink('Triggerpunktsmassage', undefined, undefined),
  },
  { label: translate('Trådning'), to: createLink('Trådning', undefined, undefined) },
  { label: translate('Träning'), to: createLink('Träning', undefined, undefined) },
  { label: translate('Tvätt & Fön'), to: createLink('Tvätt & Fön', undefined, undefined) },

  { label: translate('Vaccination'), to: createLink('Vaccination', undefined, undefined) },
  {
    label: translate('Vampyrbehandling'),
    to: createLink('Vampyrbehandling', undefined, undefined),
  },
  { label: translate('Vaxning'), to: createLink('Vaxning', undefined, undefined) },
  {
    label: translate('Vaxning brasiliansk'),
    to: createLink('Vaxning brasiliansk', undefined, undefined),
  },
  { label: translate('Veterinär'), to: createLink('Veterinär', undefined, undefined) },
  {
    label: translate('Vibrationsmassage'),
    to: createLink('Vibrationsmassage', undefined, undefined),
  },
  { label: translate('Vinyasa Yoga'), to: createLink('Vinyasa Yoga', undefined, undefined) },
  { label: translate('Volymfransar'), to: createLink('Volymfransar', undefined, undefined) },
  { label: translate('Vårtor'), to: createLink('Vårtor', undefined, undefined) },

  { label: translate('Yin Yoga'), to: createLink('Yin Yoga', undefined, undefined) },
  { label: translate('Yoga'), to: createLink('Yoga', undefined, undefined) },
  { label: translate('Yoga Nidra'), to: createLink('Yoga Nidra', undefined, undefined) },
  { label: translate('Yogamassage'), to: createLink('Yogamassage', undefined, undefined) },

  { label: translate('Zonterapi'), to: createLink('Zonterapi', undefined, undefined) },
  { label: translate('Zumba'), to: createLink('Zumba', undefined, undefined) },

  { label: translate('Ögonbryn'), to: createLink('Ögonbryn', undefined, undefined) },
  { label: translate('Ögonbrynsfärg'), to: createLink('Ögonbrynsfärg', undefined, undefined) },
  {
    label: translate('Ögonbrynstatuering'),
    to: createLink('Ögonbrynstatuering', undefined, undefined),
  },
  { label: translate('Ögonfransar'), to: createLink('Ögonfransar', undefined, undefined) },
  {
    label: translate('Ögonfransförlängning'),
    to: createLink('Ögonfransförlängning', undefined, undefined),
  },
];

export const MORE_CATEGORIES_GROUPED = MORE_CATEGORIES.reduce((acc, category) => {
  const firstLetter = category.label.charAt(0).toUpperCase();
  if (!acc[firstLetter]) {
    acc[firstLetter] = [];
  }
  acc[firstLetter]?.push(category);
  return acc;
}, {} as Record<string, MoreCategory[]>);
